import AnnouncementText from "./AnnouncementText";

export default function AnnouncementBar({ hide }: { hide: boolean }) {
    return (
        <div
            className={`
                sticky z-40
                top-[72px] lg:top-[100px] py-2
                bg-gradient-to-r from-yellow-400 to-yellow-300
                text-black text-sm
                overflow-hidden
                transition-all duration-100
                ${hide ? "-translate-y-full opacity-0" : "translate-y-0 opacity-100"}
            `}
        >
            <div className="marquee-container flex items-center justify-center">
                <div className="marquee-content ">
                    <AnnouncementText />
                </div>
            </div>
        </div>
    );
}

